import { render, staticRenderFns } from "./SpinWheel.vue?vue&type=template&id=24a4bb10&scoped=true"
import script from "./SpinWheel.vue?vue&type=script&lang=js"
export * from "./SpinWheel.vue?vue&type=script&lang=js"
import style0 from "./SpinWheel.vue?vue&type=style&index=0&id=24a4bb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a4bb10",
  null
  
)

export default component.exports